import React, { useEffect } from 'react'
import Time from './stages/Time'
import EntryType from './stages/EntryType'
import ActivityType from './stages/ActivityType'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import Options from './stages/Options'
import { useRaportForm } from '../../context/RaportFormContext'

const ComplexRaportForm = () => {
  const { setData } = useRaportForm()

  useEffect(() => {
    setData((prev: any) => ({
      availability: true,
      driving: true,
      work: true,
      rest: true,
      noData: true,
      crew: false,
      outOfScope: false,
      manualEntry: false,
      ferryTrainCrossing: false,
      crewEnabled: false,
      outOfScopeEnabled: false,
      manualEntryEnabled: false,
      ferryTrainCrossingEnabled: false,
      activityDurationMinTime: 5,
      activityDurationMinTimeEnabled: false,
      activityBetweenHoursEnabled: false,
      activityBetweenHoursStartTime: '00:00',
      activityBetweenHoursEndTime: '23:59',
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
      ...prev,
    }))
  }, [])

  return (
    <>
      <div className="tw-flex tw-flex-col tw-gap-4 tw-overflow-auto tw-p-6">
        <ActivityType />
        <DividerHorizontal />
        <EntryType />
        <DividerHorizontal />

        <Time />
        <DividerHorizontal />
        <Options />
      </div>
    </>
  )
}

export default ComplexRaportForm
